import React, { Component } from 'react';

class SignIn extends Component {
  render() {
    return <div className="text-center p-5">Please Signin</div>;
  }
}

export default SignIn;
